const localizers = {
  'loading.msg': () => `Φόρτωση...`,
  'SASServer.genericError.msg': () => `Δεν είναι δυνατή η πρόσβαση στον διακομιστή.`,
  'SASReport.genericError.msg': () => `Δεν είναι δυνατή η φόρτωση της επιλεγμένης αναφοράς.`,
  'SASReportImage.genericError.msg': () => `Απέτυχε η φόρτωση της εικόνας αναφοράς.`,
  'SASReportImage.imageNotSupported.msg': () => `Δεν υποστηρίζονται εικόνες για αυτόν τον τύπο περιεχομένου αναφοράς.`,
}
export default localizers;
